// extracted by mini-css-extract-plugin
export default {"resetButton":"ZxHApQa","root":"FSutKtq","header":"uKIu8rY","closeBtn":"IOGColg","lastLoginPreloader":"IPzRtT8","radioButtonsList":"rHqJycY"};